const hotel = {
  availableMealPlans: "Available Meal Plans",
  availableRoomsTypes: "Available Rooms Types",
  cancellationPolicy: "Cancellation Policy",
  cancellationRules: "Cancellation Rules",
  freeCancellationAvailable: "Free Cancellation Available",
  nonRefundable: "Non Refundable",
  priceFor: "Price for",
  nights: "nights",
  totalPrice: "Total price",
  seeAvailability: "See Availability",
  myProfile: "My Profile",
  travelTrust: "Travel Trust",
  signIn: "Sign In",
  searchNow: "Search Now",
  policy: "Policy",
  cxlRules: "CXL Rules",
  room: "room",
  cxlPolicy: "CXL Policy",
  beddingType: "Bedding Type",
  hotelName: "Hotel Name",
  reservationDate: "Reservation Date",
  maxPax: "Max Pax",
};

export default hotel;
